import React, { useContext, useState } from "react";
import "./Common_Login_Vendor_Details.css";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
import Subscription_Needed_Lottie_Modal from "../subscription-needed-lottie-modal/Subscription_Needed_Lottie_Modal";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";
import {
  getVendorCustomerList,
  Vendor_Call,
} from "../../../features/admin/vendor_expert/Slice";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

const Common_Login_Vendor_Details = ({ data, onCallClick }) => {
  console.log(data, "datadatadatadatadatadatadatadatadata");

  const dispatch = useDispatch();
  const { signin, userdata } = useContext(Context);
  const navigate = useNavigate();
  const [showModal2, setShowModal2] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const [showModal, setShowModal] = useState(false);

  const hasSubscription =
    Array.isArray(userdata?.user_subscription) &&
    userdata.user_subscription.length > 0;

  if (!data) return null;
  // const handleCallButtonClick = (e) => {
  //   setShowModal(true);
  //   if (onCallClick) {
  //     onCallClick(e);
  //   }
  // };
  const handleCallButtonClick = async () => {
    if (!hasSubscription) {
      setShowModal(true);
      return;
    }

    try {
      const response = await dispatch(
        Vendor_Call({
          inquiry_id: data?.id,
        }),
      ).unwrap();

      console.log("Call API Success:", response);

      await dispatch(getVendorCustomerList());

      if (onCallClick) {
        onCallClick(data);
      }
    } catch (error) {
      console.error("Call API Failed:", error);
    }
  };
  // const handleCallButtonClick = () => {
  //   if (!hasSubscription) {
  //     setShowModal(true);
  //     return;
  //   }

  //   if (onCallClick) {
  //     onCallClick(data);
  //   }
  // };

  const maskedValue = "*****";


  const showValue = (realValue) =>
    hasSubscription ? realValue || "N/A" : maskedValue;

  const handleExpandClick = () => {
    const img = data?.construction_image
      ? `${IDS.IMG_URL}${data.construction_image}`
      : "/assets/images/vendors/vendor1.png";

    setSelectedImage(img);
    setShowModal2(true);
  };

  return (
    <div className="vendor-login-card-wrapper">
      <div className="vendor-login-card-wrapper__inner">
        <div className="vendor-login-card-wrapper__image-container">
          {/* <img
            src={`${IDS.IMG_URL}${data?.construction_image}`}
            alt={data.name}
          /> */}
          <img
            className={`${hasSubscription ? "" : "blur"} inner_img`}
            src={
              data?.construction_image
                ? `${IDS.IMG_URL}${data.construction_image}`
                : "/assets/images/vendors/vendor1.png"
            }
            alt={data?.name || "Vendor"}
          />

          {!hasSubscription && (
            <p className="alert_text">Subscription Needed!</p>
          )}

          {hasSubscription && (
            <div className="expant_div" onClick={handleExpandClick}>
              <FontAwesomeIcon icon={faExpand} className="exopand_text" />
            </div>
          )}
        </div>

        <div className="vendor-login-card-wrapper__content">
          <h3 className="vendor-login-card-wrapper__title">{data.name}</h3>

          <div className="vendor-login-card-wrapper__details-grid">
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                Material :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {data?.material?.name}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                Sub Material :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {data?.sub_category?.[0]?.sub_category_inquiry?.name}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                Timeline :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {data?.purchase_date?.name}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                Contact No :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {showValue(data?.mobile_number)}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">State :-</span>
              <span className="vendor-login-card-wrapper__value">
                {showValue(data?.state?.name)}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                District :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {showValue(data?.district?.name)}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                Taluka :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {showValue(data?.taluqa?.name)}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">Area :-</span>
              <span className="vendor-login-card-wrapper__value">
                {showValue(data?.area)}
              </span>
            </div>
            <div className="vendor-login-card-wrapper__row">
              <span className="vendor-login-card-wrapper__label">
                Description :-
              </span>
              <span className="vendor-login-card-wrapper__value">
                {showValue(data?.description)}
              </span>
            </div>
          </div>

          <div className="vendor-login-card-wrapper__footer">
            <Common_Call_Button onClick2={handleCallButtonClick} />
          </div>
        </div>
      </div>
      <Subscription_Needed_Lottie_Modal
        showSubscription={showModal}
        handleSubscriptionClose={() => {
          setShowModal(false);
          navigate("/wallet");
        }}
      />

      <Modal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        centered
        size="lg"
      >
        <Modal.Body className="p-0 text-center">
          <div className="main_show_img_modal_div">
            <div className="showImg_modal">
              <img src={selectedImage} alt="Expanded" className="inner_img" />
            </div>

            <div
              className="icon_holder"
              onClick={() => {
                setShowModal2(false);
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/icon/close.png"}
                className="close_img"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Common_Login_Vendor_Details;
